// Traduções específicas para a página de compra direta - Português (Brasil)
export const buyDirectPt = {
  hero: {
    title: 'Compramos Seu Carro',
    description:
      'Venda seu veículo de forma rápida, segura e pelo melhor preço. Avaliação justa e pagamento imediato.',
  },
  form: {
    firstName: 'Nome',
    lastName: 'Sobrenome',
    email: 'E-mail',
    phone: 'Telefone',
    brand: 'Marca',
    brandPlaceholder: 'Selecione uma marca',
    model: 'Modelo',
    modelPlaceholder: 'Selecione um modelo',
    year: 'Ano',
    mileage: 'Quilometragem',
    condition: 'Condição do Veículo',
    askingPrice: 'Preço pretendido',
    message: 'Detalhes adicionais',
    plate: 'Placa', // BR: patente → placa
    platePlaceholder: 'Ex: ABCD12', // BR: exemplo mantido no formato chileno (o validador normalizarPatente é chileno)
    plateInvalid: 'Confira a placa: são letras e números, como ABCD12.', // BR: patente → placa; exemplo chileno mantido (validador)
    version: 'Versão (opcional)',
    versionPlaceholder: 'Ex: EXL 1.5 CVT',
    submit: 'Solicitar Avaliação',
  },
  info: {
    advantagesTitle: 'Por Que Vender Seu Carro para a Gente',
    benefitsTitle: 'Nossas vantagens',
    benefitsList: {
      item1: 'Avaliação justa com base no valor real de mercado',
      item2: 'Pagamento imediato garantido',
      item3: 'Cuidamos de toda a documentação',
      item4: 'Sem custos ocultos nem comissões',
      item5: 'Processo rápido e seguro',
    },
    processTitle: 'Processo de venda',
    processList: {
      step1: 'Envio das informações básicas do veículo',
      step2: 'Avaliação técnica do veículo',
      step3: 'Proposta formal de compra',
      step4: 'Assinatura dos documentos e transferência',
      step5: 'Pagamento imediato',
    },
    directContactTitle: 'Contato Direto',
    emailLabel: 'E-mail',
    phoneLabel: 'Telefone',
  },
  embed: {
    infoTitle: 'Como funciona?',
    steps: [
      { title: 'Envie seus dados', desc: 'Preencha o formulário com as informações do seu veículo.' },
      { title: 'Avaliamos', desc: 'Nossa equipe analisa os dados e avalia seu veículo.' },
      { title: 'Fazemos uma proposta', desc: 'Você receberá uma proposta justa e transparente.' },
      { title: 'Pagamento imediato', desc: 'Se você aceitar, fazemos o pagamento na hora.' },
    ],
    benefitsTitle: 'Benefícios',
    benefits: ['Proposta na hora', 'Pagamento imediato', 'Sem comissões ocultas', 'Documentação inclusa'],
  },
};
